module.exports = __webpack_public_path__ + "static/media/transactional-platform.5380fbe6.jpg";